import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { IGetPersonaResponse } from '../../interfaces/response/IGetPersonaResponse';
import IHttpResponse from '../../interfaces/shared/IHttpResponse';
import { Observable } from 'rxjs';
import { APP_BASE_HREF } from '@angular/common';

export interface IGetPersonaByUuid {
  idPersona: number;
  uuid: string;
  email: string;
  nombre: string;
  apellido1: string;
  apellido2: string;
  numDocumento: string;
}

@Injectable({
  providedIn: 'root',
})
export class PersonaService {

  url = "";

  constructor(private http: HttpClient, @Inject(APP_BASE_HREF) private baseHref: string) {
    this.url = baseHref + environment.apis.person;
  }

  getPersona() {
    return this.http
      .get<IGetPersonaResponse>(`${this.url}/Persona`)
      .pipe(map((resp: any) => resp.data));
  }

  getPersonaFromCotizacionURL(idCotizacion: string) {
    return this.http.get<any>(`${this.url}/Persona/gestionurl/${idCotizacion}`);
  }

  getPersonaByUuid(uuid: String) {
    return this.http.get<IHttpResponse<IGetPersonaByUuid>>(
      `${this.url}/Persona/${uuid}`
    );
  }

  getAddressAutocompleteData(input: any): Observable<any> {
    return this.http.get<any>(`${this.url}/Google/place/${input}`);
  }


  getAddressAutocompleteDataDetail(place_id: any): Observable<any> {
    return this.http.get<any>(`${this.url}/Google/details/${place_id}`);
  }
}
